import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { MapService } from '../services/map.service';
import * as L from 'leaflet';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, AfterViewInit {
  protected height : string = '0px';
  private currentParams : Params;

  constructor(
    private route: ActivatedRoute,
    private mapService : MapService
  ) {
    this.route.params.subscribe(params => {
      this.currentParams = params;
  });
  }

  ngOnInit(): void {
  }

  async ngAfterViewInit(): Promise<void> {
    this.map = await this.mapService.initMap();
  }

  private map : L.Map;

}
